import { ICategory } from './../interfaces/ICategories';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private URL: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  categoriesList(): Observable<any> {
    return this.http.get<any>(`${this.URL}departments`).pipe(
      (res) => res,
      (err) => err
    );
  }
}
